import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { APIService } from '../apiservices/apiservices';

@Injectable()

export class SegmentoProvider {
  private header=APIService.getHeader();
  itemret;

  constructor(public http: HttpClient) {
  }
  
  /**
   * Lista segmentos
   * @param params? parâmetros de filtro segmento
   * @returns 
   */
  get(params?: any) {
    var me=this;
    this.header=APIService.getHeader();

    return new Promise((resolve, reject) => {
  
      let url = APIService.API_URL + 'segmento';

      const uri = new URL(url);

      if (params) {
        Object.keys(params).forEach(key => uri.searchParams.append(key, params[key]));
      }

      url = uri.toString();
      
      me.http.get(url,{headers:me.header})
        .subscribe((result: any) => {
          ////console.log(result);
          //resolve(result.json());
          var jsonData=result;

          if (jsonData.length!=0)
          {
            if (jsonData[0].status_ret!="NOK")
            {
                var datasuccess={
                  'Item':jsonData,
                  'erro':''
                }
                me.itemret=datasuccess;
            }
            else{
              var errodatavazio={
                'Item':null,
                'erro':'Erro na consulta dos contratos.'
              }
              me.itemret=errodatavazio;
            }
            
            //resolve(me.itemret);
          }
          else{
            var errodatavazio1={
              'Item':null,
              'erro':'Nenhum registro encontrado.'
            }
            me.itemret=errodatavazio1;
          }
          resolve(me.itemret);
        },
        (error) => {
          var msg="";
          if (error.status==401){
            msg=error.statusText;
          }
          else{
            msg=error.error;
          }
          let errojson =msg;

          var errochamada={
            'Item':null,
            'erro':errojson
          }
          me.itemret=errochamada;
          reject(me.itemret);
          
        });
    });
  }

  /**
   * Atualiza usuário
   * @param dadosJson json com os dados do usuário
   * @returns 
   */
  addupdate(dadosJson:any) {
    var me=this;
    this.header=APIService.getHeader();

    return new Promise((resolve, reject) => {
  
      var requestData=JSON.stringify(dadosJson);
      let url = APIService.API_URL + 'contrato';
      //console.log(requestData);
      me.http.post(url,requestData,{headers:me.header})
        .subscribe((result: any) => {
          
          var jsonData=result;

          if (jsonData.length!=0)
          {
            if (jsonData.status_ret!="NOK")
            {
                var datasuccess={
                  'Item':jsonData,
                  'erro':''
                }
                me.itemret=datasuccess;
            }
            else{
              //console.log(jsonData.erro);
              var errodatavazio={
                'Item':null,
                'erro':'Erro na atualização do contrato.'
              }
              me.itemret=errodatavazio;
            }
            
            resolve(me.itemret);
          }
          else{
            var errodatavazio1={
              'Item':null,
              'erro':'Não há consultas.'
            }
            me.itemret=errodatavazio1;
          }
        },
        (error) => {
          var msg="";
          if (error.status==401){
            msg=error.statusText;
          }
          else{
            msg=error.error;
          }
          let errojson =msg;

          var errochamada={
            'Item':null,
            'erro':errojson
          }
          me.itemret=errochamada;
          reject(me.itemret);
          
        });
    });
  }


  delete(id:any) {
    var me=this;
    this.header=APIService.getHeader();

    return new Promise((resolve, reject) => {
  
      let url = APIService.API_URL + 'contrato?id=' + id;
      
      me.http.delete(url,{headers:me.header})
        .subscribe((result: any) => {
          ////console.log(result);
          //resolve(result.json());
          var jsonData=result;

          if (jsonData.length!=0)
          {
            if (jsonData.status_ret!="NOK")
            {
                var datasuccess={
                  'Item':jsonData,
                  'erro':''
                }
                me.itemret=datasuccess;
            }
            else{
              var errodatavazio={
                'Item':null,
                'erro':'Erro na exclusão do contrato.'
              }
              me.itemret=errodatavazio;
            }
            
            resolve(me.itemret);
          }
          else{
            var errodatavazio1={
              'Item':null,
              'erro':'Nenhum registro encontrado.'
            }
            me.itemret=errodatavazio1;
          }
        },
        (error) => {
          var msg="";
          if (error.status==401){
            msg=error.statusText;
          }
          else{
            msg=error.error;
          }
          let errojson =msg;

          var errochamada={
            'Item':null,
            'erro':errojson
          }
          me.itemret=errochamada;
          reject(me.itemret);
          
        });
    });
  }

  
  

}
